import { axiosConfig, type RequestConfig } from "../shared/api-client";
import { JIVANDHARA_BASE } from "../admin/list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/csr-partnership-inquiries`;
const SILENT: RequestConfig = { showNotification: false };

export interface CsrPartnershipInquiryPayload {
  company_name: string;
  contact_person_name: string;
  official_email: string;
  mobile_number: string;
  designation?: string;
  /** Comma-separated list, e.g. "Healthcare, Elderly Care" */
  partnership_interests: string;
  estimated_contribution?: string;
  partnership_duration?: string;
  message?: string;
  privacy_consent: boolean;
}

class CsrPartnershipService {
  create = async (payload: CsrPartnershipInquiryPayload): Promise<void> => {
    const form = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        form.append(key, String(value));
      }
    });
    await axiosConfig.post(`${BASE}/`, form, {
      ...SILENT,
      headers: { "Content-Type": "multipart/form-data" },
    });
  };
}

export const csrPartnershipService = new CsrPartnershipService();
